interface Props {
    src?: string | null;
    name?: string;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    square?: boolean;
    logo?: boolean;
    status?: "online" | "away" | "offline";
    className?: string;
}

function initialsOf(name?: string): string {
    const parts = (name || "").trim().split(/\s+/).filter(Boolean);
    if (!parts.length) {
        return "?";
    }
    return ((parts[0]?.[0] ?? "") + (parts[1]?.[0] ?? "")).toUpperCase();
}

export function MkAvatar({ src, name, size = "md", square, logo, status, className }: Props) {
    const classes = ["mk-avatar", `mk-avatar-${size}`,
                     square ? "mk-avatar-square" : "",
                     logo && src ? "mk-avatar-logo" : "",
                     className ?? ""].filter(Boolean).join(" ");
    return (
        <span className={classes}>
            {src ? <img src={src} alt="" />
                 : <span className="mk-avatar-initials">{initialsOf(name)}</span>}
            {status && <span className={`mk-avatar-status mk-status-${status}`} />}
        </span>
    );
}
